<template>
  <div class="pa-4">
    <RichText
      v-model="store.plan.work_management_metrics"
      label="6.1 Work Management Metrics"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <WorkManagementMetricsLinkTable
      class="mb-4"
      :readonly="readonly"
      @delete="emit('delete', $event)"
    />
    <RichText
      v-model="store.plan.reliability_metrics"
      label="6.2 Reliability Metrics"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <ReliabilityMetricsLinkTable
      class="mb-4"
      :readonly="readonly"
      @delete="emit('delete', $event)"
    />
    <v-card variant="outlined" rounded="lg">
      <v-toolbar density="compact">
        <v-toolbar-title>6.3 PM02/PM03</v-toolbar-title>
      </v-toolbar>
      <PM02PM03Chart
        class="pa-3"
        hide-title
        chart-height="500px"
        :floc-ids="
          store.plan.floc_boundaries.map((b) => b.functional_location_id)
        "
      />
    </v-card>
  </div>
</template>

<script setup lang="ts">
import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";
import PM02PM03Chart from "@/components/metrics/PM02PM03Chart.vue";
import ReliabilityMetricsLinkTable from "../links/ReliabilityMetricsLinkTable.vue";
import WorkManagementMetricsLinkTable from "../links/WorkManagementMetricsLinkTable.vue";
import { Deleteable } from "@/classes/asset-management-plan";

const props = defineProps<{
  readonly: boolean;
}>();

const emit = defineEmits<{
  delete: [item: Deleteable];
}>();

const store = useAMPStore();
</script>
